import { SortOrder, sortBasedOnRecentBomOptionsList } from './utils';
import { getChildOptionDict, getUniqueOptions } from '../../bom/selectors';
import {
  getCurrentBomOption,
  getCurrentEditedBomOption,
  getProductDetailsInterfaceSettings,
  getRecentBomOptionsList,
} from '../product/selectors';
import { useEffect, useRef, useState } from 'react';

import { useSelector } from 'react-redux';

export const useSelectedUniqueOptions = (code) => {
  const options = useSelector((state) => getUniqueOptions(state, code));
  const recentBomOptionsList = useSelector(getRecentBomOptionsList);

  const settings = useSelector(getProductDetailsInterfaceSettings);
  const { showing } = settings;

  const [selectedOptions, setSelectedOptions] = useState(() =>
    sortBasedOnRecentBomOptionsList(
      options.filter((option) => option.isSelected),
      recentBomOptionsList,
      SortOrder.Asc
    )
  );

  useEffect(() => {
    if (showing) {
      return;
    }

    setSelectedOptions(
      sortBasedOnRecentBomOptionsList(
        options.filter((option) => option.isSelected),
        recentBomOptionsList,
        SortOrder.Asc
      )
    );
  }, [options, recentBomOptionsList, showing]);

  return selectedOptions;
};

export const useChildOptionDictionary = (childQuestionCode) => {
  const dict = useSelector((state) => getChildOptionDict(state, childQuestionCode));

  const settings = useSelector(getProductDetailsInterfaceSettings);
  const { showing } = settings;

  const [childOptionDict, setChildOptionDict] = useState(dict);

  useEffect(() => {
    if (showing) return;
    setChildOptionDict(dict);
  }, [dict, showing]);

  return childOptionDict;
};

export const useCurrentEditedQuantityCardScrollIntoView = (selectedBomOptions) => {
  const quantityCardRef = useRef(null);
  const currentBomOption = useSelector(getCurrentBomOption);

  useEffect(() => {
    if (!!quantityCardRef && !!quantityCardRef.current) {
      quantityCardRef.current.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }, []);

  const currentEditedQuantityCardIndex =
    !!currentBomOption && !!selectedBomOptions && Array.isArray(selectedBomOptions) && selectedBomOptions.length > 0
      ? selectedBomOptions.findIndex(
          (option) => option.code === currentBomOption.code && option.codeValue === currentBomOption.codeValue
        )
      : -1;

  return [quantityCardRef, currentEditedQuantityCardIndex];
};

export const useCurrentEditedQuantityInputGetFocused = (selectedBomOptions) => {
  const quantityInputRef = useRef(null);
  const currentEditedBomOption = useSelector(getCurrentEditedBomOption);

  useEffect(() => {
    if (!!currentEditedBomOption && !!quantityInputRef && !!quantityInputRef.current) {
      quantityInputRef.current.focus();
    }
  }, [currentEditedBomOption]);

  const currentEditedQuantityInputIndex =
    !!currentEditedBomOption &&
    !!selectedBomOptions &&
    Array.isArray(selectedBomOptions) &&
    selectedBomOptions.length > 0
      ? selectedBomOptions.findIndex(
          (option) =>
            option.code === currentEditedBomOption.code && option.codeValue === currentEditedBomOption.codeValue
        )
      : -1;

  return [quantityInputRef, currentEditedQuantityInputIndex];
};
